import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { avatarImage } from '@/assets';
import { NavTabs } from '@/components';
import { RouteKeys } from '@/configs';
import { useMemo } from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import styles from './index.module.less';
import { MaskboxCollections } from './MaskboxCollections';
import { OtherCollections } from './OtherCollections';
import { useLocales } from './useLocales';
export const Profile = () => {
    const t = useLocales();
    const tabs = useMemo(() => [
        {
            key: 'maskbox',
            to: RouteKeys.ProfileMaskboxCollections,
            label: t('MaskBox Collectibles'),
        },
        {
            key: 'others',
            to: RouteKeys.ProfileOtherCollections,
            label: t('Other Collectibles'),
        },
    ], [t]);
    return (_jsxs("article", { children: [_jsx("header", { className: styles.header, children: _jsx("img", { className: styles.avatar, height: 96, width: 96, src: avatarImage }) }), _jsxs("main", { className: styles.main, children: [_jsx(NavTabs, { tabs: tabs }), _jsxs(Switch, { children: [_jsx(Route, { path: RouteKeys.ProfileMaskboxCollections, component: MaskboxCollections }), _jsx(Route, { path: RouteKeys.ProfileOtherCollections, component: OtherCollections }), _jsx(Redirect, { to: RouteKeys.ProfileMaskboxCollections })] })] })] }));
};
